import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from "src/provider/API/call-service"
import { AbsoluteContainer, AppSpan, Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
import { handleTypeNumberControl } from "src/utils/utility"
import { BsEyeSlash, BsEye } from "react-icons/bs"

export const ChangePin: React.FC<any> = ({close}) => {
    const navigate = useNavigate()
    const {notifier} = useContext(VisibilityContext)
    const {logout} = useContext(AppInfoContext)
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({oldPin: '', newPin: '', confirmPin: ''})
    const [showPin, setShowPin] = useState({currentPin: false, newPin: false, confirmPin: false})

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value.replaceAll('.', '')
        if (e.target.value.length <= 4) {
            setInput({...input, [e.target.name]: e.target.value})
        }
    }
    
    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (input.oldPin.length != 4 || input.newPin.length != 4) return notifier.show('Kindly provide a valid PIN', 'Validation Response')
        if (input.confirmPin != input.newPin) return notifier.show("PINs did not match", 'Validation Response')
        
        const response = await API.changePin_Password(input, true)
        if (response) {
            await logout()
            navigate('/login')
        }
        else close()
    }

    return (
        <>
            <SidePopupLayout close={close}>
                <ScreenTitle textSize="2.2" fontWeight="700">Change PIN</ScreenTitle>
                <CustomContainer topMargin='2.5'>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <label>Current PIN</label>
                            <input 
                                type={showPin.currentPin ? 'text' : 'password'}
                                placeholder='Enter Current PIN' 
                                name='oldPin'
                                value={input.oldPin}
                                onChange={handleInput}
                                onBlur={handleInput}
                                onKeyDown={handleTypeNumberControl}
                                onKeyUp={handleTypeNumberControl}
                                autoComplete="off"
                                required
                            />
                            { !showPin.currentPin ?
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPin({...showPin, currentPin: true})}
                                    >
                                        <BsEyeSlash/>
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPin({...showPin, currentPin: false})}
                                    >
                                        <BsEye/>
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </FormGroup>
                        <FormGroup>
                            <label>New PIN</label>
                            <input 
                                type={showPin.newPin ? 'text' : 'password'}
                                placeholder='Enter New PIN' 
                                name='newPin'
                                value={input.newPin}
                                onChange={handleInput}
                                onBlur={handleInput}
                                onKeyDown={handleTypeNumberControl}
                                onKeyUp={handleTypeNumberControl}
                                autoComplete="off"
                                required
                            />
                            { !showPin.newPin ?
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPin({...showPin, newPin: true})}
                                    >
                                        <BsEyeSlash/>
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPin({...showPin, newPin: false})}
                                    >
                                        <BsEye/>
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </FormGroup>
                        <FormGroup>
                            <label>Confirm New PIN</label>
                            <input 
                                type={showPin.confirmPin ? 'text' : 'password'}
                                placeholder='Enter PIN' 
                                name='confirmPin'
                                value={input.confirmPin}
                                onChange={handleInput}
                                onBlur={handleInput}
                                onKeyDown={handleTypeNumberControl}
                                onKeyUp={handleTypeNumberControl}
                                autoComplete="off"
                                required
                            />
                            { !showPin.confirmPin ?
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPin({...showPin, confirmPin: true})}
                                    >
                                        <BsEyeSlash/>
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPin({...showPin, confirmPin: false})}
                                    >
                                        <BsEye/>
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </FormGroup>
                        
                        <FlexRow justifyContent='flex-end' topMargin='2.5'>
                            <Button 
                                width='8.8' height='4' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Confirm
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </SidePopupLayout>
        </>
    )
}